import React, { useState, useEffect } from 'react';
import { useGET } from 'hooks/useRequest';

import ProductPricing from 'components/products/product_pricing';
import CEFMessage from 'components/cef_message/cef_message';
import StoreAddressBox from './store_address_box';
import warningIcon from '../../../assets/images/shared/icons/info.svg';

/**
 * @param {Object} props
 * @param {boolean} props.catalogue - Current product catalogue code
 * @param {boolean} props.productId - Current product ID
 * @param {function} props.vatStatus - Vat status of site
 * @param {boolean} props.currentProductName - Full description of current product
 * @param {function} props.currentStore - The Current store information if available
 * @param {function} props.collectionLocationSet - Bool to show if user has a store set
 * @param {function} props.selectAStoreUrl - URL for change store page
 * @returns Renewables product right hand column for product detail page
 */

const RenewablesProductShowColumn = ({
  catalogue,
  productId,
  vatStatus,
  currentProductName,
  currentStore,
  collectionLocationSet,
  selectAStoreUrl,
}) => {
  const [productPrice, setProductPrice] = useState();

  const { data: priceResponse, loading } = useGET(
    `/product_price?products=${productId}`,
  );

  useEffect(() => {
    if (priceResponse) {
      setProductPrice(priceResponse[productId]);
    }
  }, [priceResponse]);

  if (!productPrice) {
    return null;
  }

  return (
    <div>
      <ProductPricing
        v1
        id={productId}
        isLoading={loading}
        prices={productPrice}
        vatStatus={vatStatus}
      />

      <CEFMessage
        icon={warningIcon}
        title="Order via your local store"
        classNames="fl-col"
        // eslint-disable-next-line max-len
        text="This product requires special delivery. Please call, email or visit your local store to place an order."
      />

      {!collectionLocationSet ? (
        <a
          href={selectAStoreUrl}
          className="cef-btn cef-btn--green cef-btn--full-width fs-16 fw-500">
          Find a Store
        </a>
      ) : (
        <StoreAddressBox
          catalogue={catalogue}
          icon={warningIcon}
          currentProductName={currentProductName}
          selectAStoreUrl={selectAStoreUrl}
          currentStore={currentStore}
          showTelephoneLink
          showEmailLink
          showStoreIcon
        />
      )}
    </div>
  );
};

export default RenewablesProductShowColumn;
